(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/play/views/betslip.js') >= 0) return;  svs.modules.push('/modules/keno/components/play/views/betslip.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.keno=_svs.keno||{};
_svs.keno.components=_svs.keno.components||{};
_svs.keno.components.play=_svs.keno.components.play||{};
_svs.keno.components.play.templates=_svs.keno.components.play.templates||{};
svs.keno.components.play.templates.betslip = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id='rowPriceRegion'></div>\n<div id='drawCountRegion'></div>\n<div id='trissRegion'></div>\n<div class='numbergames-footer-section'>\n  <div id='accountSelectorRegion'></div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-keno-components-play-betslip'] = svs.keno.components.play.templates.betslip;
})(svs, Handlebars);


 })(window);